<template>
  <div>
    <h5 class="text-primary mt-4">INCLUSIÓN / EXCLUSIÓN DE ÍTEMS</h5>
    <b-tabs class="mt-3">
      <b-tab title="Inclusión de Ítems">
        <div v-for="(inclusion, index) in inclusiones" :key="index">
          <b-row v-if="inclusionCurPage == index + 1">
            <b-col sm="3">
              <b-form-group label="Fecha inclusión:">
                <b-form-input
                  type="date"
                  v-model="inclusion.fecha"
                  :min="minDate"
                  :max="maxDate"
                  @blur="$v.inclusiones.$each[index].fecha.$touch"
                  :state="$v.inclusiones.$each[index].fecha.$dirty ? !$v.inclusiones.$each[index].fecha.$error : null"
                />
              </b-form-group>
              <b-form-group label="Fecha de nacimiento:">
                <b-form-input
                  type="date"
                  v-model="inclusion.nacimiento"
                  :max="minDate"
                  @blur="$v.inclusiones.$each[index].nacimiento.$touch"
                  :state="$v.inclusiones.$each[index].nacimiento.$dirty ? !$v.inclusiones.$each[index].nacimiento.$error : null"
                />
              </b-form-group>
            </b-col>
            <b-col sm="9">
              <b-form-group label="Nombre y Apellido:">
                <b-form-input
                  type="text"
                  v-model="inclusion.nombre"
                  @blur="$v.inclusiones.$each[index].nombre.$touch"
                  :state="$v.inclusiones.$each[index].nombre.$dirty ? !$v.inclusiones.$each[index].nombre.$error : null"
                />
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group label="DNI / CUIL:">
                <b-form-input
                  type="text"
                  v-model="inclusion.documento"
                  @blur="$v.inclusiones.$each[index].documento.$touch"
                  :state="$v.inclusiones.$each[index].documento.$dirty ? !$v.inclusiones.$each[index].documento.$error : null"
                />
              </b-form-group>
            </b-col>
            <b-col sm="5">
              <b-form-group label="E-Mail:">
                <b-form-input
                  type="email"
                  v-model="inclusion.email"
                  @blur="$v.inclusiones.$each[index].email.$touch"
                  :state="$v.inclusiones.$each[index].email.$dirty ? !$v.inclusiones.$each[index].email.$error : null"
                />
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group label="Teléfono:">
                <b-form-input
                  type="tel"
                  v-model="inclusion.telefono"
                  @blur="$v.inclusiones.$each[index].telefono.$touch"
                  :state="$v.inclusiones.$each[index].telefono.$dirty ? !$v.inclusiones.$each[index].telefono.$error : null"
                />
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group label="Dirección:">
                <b-form-input
                  type="text"
                  v-model="inclusion.direccion"
                  @blur="$v.inclusiones.$each[index].direccion.$touch"
                  :state="$v.inclusiones.$each[index].direccion.$dirty ? !$v.inclusiones.$each[index].direccion.$error : null"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <hr />
        <b-row>
          <b-col>
            <b-btn size="sm" variant="primary" @click="addInclusion">
              <i class="fa fa-plus-square-o"></i>
              Incluir otro ítem
            </b-btn>&nbsp;
            <b-btn
              size="sm"
              variant="danger"
              v-if="inclusiones.length > 1"
              @click="delInclusion(inclusionCurPage - 1)"
            >
              <i class="fa fa-trash-o"></i> Quitar
            </b-btn>
          </b-col>
          <b-col>
            <b-pagination-nav
              :link-gen="paginate"
              class="domicilios-nav"
              v-if="inclusiones.length > 1"
              size="sm"
              v-model="inclusionCurPage"
              :number-of-pages="inclusiones.length"
            ></b-pagination-nav>
          </b-col>
        </b-row>
      </b-tab>

      <!-- exclusion de items -->
      <b-tab title="Exclusión de Ítems">
        <div v-for="(exclusion, index) in exclusiones" :key="index">
          <b-row v-if="exclusionCurPage == index + 1">
            <b-col sm="3">
              <b-form-group label="Fecha exclusión:">
                <b-form-input
                  type="date"
                  v-model="exclusion.fecha"
                  :min="minDate"
                  :max="maxDate"
                  @blur="$v.exclusiones.$each[index].fecha.$touch"
                  :state="$v.exclusiones.$each[index].fecha.$dirty ? !$v.exclusiones.$each[index].fecha.$error : null"
                />
              </b-form-group>
            </b-col>
            <b-col sm="9">
              <b-form-group label="Asegurado:">
                <!--
                <autocomplete
                  :data="asegurados"
                  input-class="form-control"
                  @selected="setItem($event, index)"
                  placeholder="Buscar asegurado ..."
                  :loading="!asegurados.length"
                  loadingCaption="Cargando asegurados ..."
                />
                -->
                <b-form-select
                  :options="asegurados"
                  input-class="form-control"
                  @change.native="setItem"
                  placeholder="Buscar asegurado ..."
                />
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <hr />
        <b-row>
          <b-col>
            <b-btn size="sm" variant="primary" @click="addExclusion">
              <i class="fa fa-plus-square-o"></i>
              Excluir otro ítem
            </b-btn>&nbsp;
            <b-btn
              size="sm"
              variant="danger"
              v-if="exclusiones.length > 1"
              @click="delExclusion(exclusionCurPage - 1)"
            >
              <i class="fa fa-trash-o"></i> Quitar
            </b-btn>
          </b-col>
          <b-col>
            <b-pagination-nav
              :link-gen="paginate"
              class="domicilios-nav"
              v-if="exclusiones.length > 1"
              size="sm"
              v-model="exclusionCurPage"
              :number-of-pages="exclusiones.length"
            ></b-pagination-nav>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
    <b-card class="mt-2" style="border-radius: 0">
      <b-card-text>
        <b-form-textarea
          rows="4"
          placeholder="Comentarios adicionales"
          v-model="comentarios"
          @blur="$v.comentarios.$touch"
          :state="$v.comentarios.$dirty ? !$v.comentarios.$error : null"
        />
      </b-card-text>
    </b-card>
    <div class="submit-footer">
      <b-row>
        <b-col></b-col>
        <b-col class="text-right">
          <b-btn
            variant="success"
            @click="submit"
            v-b-tooltip.hover
            title="La presente solicitud está sujeta a aprobación. Los cambios no se guardarán de manera instantánea."
          >
            <i class="fa fa-send-o" v-if="!sending"></i>
            <i class="fa fa-spinner fa-spin" v-else></i>
            Enviar Solicitud
          </b-btn>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Autocomplete from '@/components/Autocomplete';
import { required, requiredIf, email, integer } from 'vuelidate/lib/validators';
import moment from 'moment';

export default {
  components: {
    Autocomplete
  },
  props: ['nroPoliza', 'tomador', 'endoso'],
  data() {
    return {
      sending: false,
      inclusiones: [{}],
      inclusionCurPage: 1,
      exclusiones: [{}],
      exclusionCurPage: 1,
      comentarios: '',
      asegurados: [],
      minDate: moment().format('YYYY-MM-DD'),
      maxDate: moment()
        .add(30, 'day')
        .format('YYYY-MM-DD')
    };
  },
  validations: {
    inclusiones: {
      required,
      $each: {
        fecha: {
          required: requiredIf(function() {
            return !this.allIncEmpty;
          })
        },
        nombre: {
          required: requiredIf(function() {
            return !this.allIncEmpty;
          })
        },
        nacimiento: {
          required: requiredIf(function() {
            return !this.allIncEmpty;
          })
        },
        documento: {
          required: requiredIf(function() {
            return !this.allIncEmpty;
          })
        },
        email: { email },
        telefono: {
          required: requiredIf(function() {
            return !this.allIncEmpty;
          })
        },
        direccion: {
          required: requiredIf(function() {
            return !this.allIncEmpty;
          })
        }
      }
    },
    exclusiones: {
      required,
      $each: {
        fecha: {
          required: requiredIf(function() {
            return !this.allExcEmpty;
          })
        },
        nombre: {
          required: requiredIf(function() {
            return !this.allExcEmpty;
          })
        },
        nroItem: {
          required: requiredIf(function() {
            return !this.allExcEmpty;
          }),
          integer
        }
      }
    },
    comentarios: { required }
  },
  methods: {
    /**
     * Setea el item seleccionado en la exclusión
     */
    setItem(event) {
      let val = event.target.options[event.target.selectedIndex];
      let index = this.exclusiones.length-1;

      let nombre = val.text.split(' | ')[2].replace('Nombre:', '');
      let nroItem = val.value;
      this.exclusiones[index].nombre = nombre;
      this.exclusiones[index].nroItem = nroItem;
    },
    submit: async function() {
      this.$v.$touch();

      if (this.allIncEmpty && this.allExcEmpty) {
        this.$toast.error('Debe completar al menos un formulario.');
        return null;
      }

      if (this.$v.$invalid) {
        this.$toast.error('La solicitud que intenta enviar posee campos incompletos o incorrectos.');
        return null;
      }

      this.sending = true;

      await this.$api
        .post(`endoso/solicitud/inc-exc-items/${this.tomador}`, {
          pas: {
            nombre: (this.$store.state.auth.nombre + ' ' + this.$store.state.auth.apellido).replace('null',''),
            codigo: this.$store.state.auth.cod_agente,
            email: this.$store.state.auth.email
          },
          poliza: this.nroPoliza,
          inclusiones: this.allIncEmpty ? null : this.inclusiones,
          exclusiones: this.allExcEmpty ? null : this.exclusiones,
          comentarios: this.comentarios
        })
        .then(() => {
          this.$toast.success('Solicitud de endoso enviada exitosamente');
        })
        .catch(err => {
          //console.log(err.response);
          this.$toast.error('Ocurrió un error al intentar enviar la solicitud');
        });
      this.sending = false;
    },
    addInclusion() {
      this.inclusiones.push({});
      this.inclusionCurPage++;
    },
    delInclusion(index) {
      this.inclusiones.splice(index, 1);
      this.inclusionCurPage = index > 1 ? index : 1;
    },
    addExclusion() {
      this.exclusiones.push({});
      this.exclusionCurPage++;
    },
    delExclusion(index) {
      this.exclusiones.splice(index, 1);
      this.exclusionCurPage = index > 1 ? index : 1;
    },
    paginate() {
      return null;
    }
  },
  computed: {
    allIncEmpty() {
      return !this.inclusiones.every(item => Object.values(item).some(val => val));
    },
    allExcEmpty() {
      return !this.exclusiones.every(item => Object.values(item).some(val => val));
    }
  },
  created: async function() {
    this.asegurados = await this.$api(`polizas/asegurados/${this.nroPoliza}`).then(res => {
      return res.data.map(item => ({
        text: 'Item Nro.: ' + item.nro_item + ' | Doc.: ' + item.documento + ' | Nombre: ' + item.nombre,
        value: item.cod_aseg
      }));
    });
  }
};
</script>
